import { render } from "./TransactionListRecent.vue?vue&type=template&id=f7f4525e&scoped=true&ts=true"
import script from "./TransactionListRecent.vue?vue&type=script&lang=ts"
export * from "./TransactionListRecent.vue?vue&type=script&lang=ts"

import "./TransactionListRecent.vue?vue&type=style&index=0&id=f7f4525e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7f4525e"]])

export default __exports__